/**
 * Control Doctors Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import Swal from 'sweetalert2';
import AppConfig from "../../../constants/AppConfig";
import {store} from "../../store";
// States
const state = {
    controlDoctors: [],
    controlDoctor: {}
};

// Getters
const getters = {
    controlDoctors: state => {
        return state.controlDoctors
    },

    controlDoctor: state => {
        return state.controlDoctor
    }
};

// Actions
const actions = {
    getControlDoctors(context, payload) {
        function successCallback(response) {
            context.commit('getControlDoctorsHandler', { controlDoctors: response.data.medecins });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.ControlDoctor.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getControlDoctor(context, payload) {
        function successCallback(response) {
            context.commit('getControlDoctorHandler', { controlDoctor: response.data.medecin });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.ControlDoctor.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createControlDoctor(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            if(response.data.hasOwnProperty('message')){
                Swal.fire(
                    response.data.message,
                    '',
                    'warning'
                );
            }
            router.push({ name: 'control-doctor', params: { doctor:response.data.medecin.slug } });
        }

        function errorCallback(error) {
            store.dispatch('record', {errors : error.response.data.error});
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        // makeApiRequest(payload.args, apiModel.ControlDoctor.Create, localToken, successCallback, errorCallback, payload.errorMessages);
        let url = AppConfig.apiUrl + apiModel.ControlDoctor.Create.url;

        Vue.axios.post(
            url,
            payload.args,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        )
            .then(successCallback)
            .catch(errorCallback);
    },

    updateControlDoctor(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            store.dispatch('findAndRemove', {name: 'control-doctor' });

            router.push({ name: 'control-doctor', params: { doctor:response.data.medecin.slug } });

        }

        function errorCallback(error) {
            store.dispatch('record', {errors : error.response.data.error});
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        // makeApiRequest(payload.args, apiModel.ControlDoctor.Update, localToken, successCallback, errorCallback, payload.errorMessages);

        let url = AppConfig.apiUrl + apiModel.ControlDoctor.Create.url + '/' + payload.doctor;

        Vue.axios.post(
            url,
            payload.args,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        )
            .then(successCallback)
            .catch(errorCallback);
    },

    deleteControlDoctor(context, payload) {
        function successCallback(response) {
            context.commit('deleteControlDoctorHandler', { index: payload.index, successMessage: payload.successMessage });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.ControlDoctor.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

// Mutations
const mutations = {
    getControlDoctorsHandler(state, { controlDoctors }) {
        // Update controlDoctors state
        state.controlDoctors = controlDoctors;
    },

    getControlDoctorHandler(state, { controlDoctor }) {
        // Update controlDoctor state
        state.controlDoctor = controlDoctor;
    },

    deleteControlDoctorHandler(state, { index, successMessage }) {
        let i = state.controlDoctors.findIndex(controlDoctor => controlDoctor.slug === index);

        if (~i) {
            state.controlDoctors.splice(i, 1);

            router.push({ name: 'control-doctors' });

            Vue.swal(
                successMessage,
                '',
                'success'
            );
        }
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}